import { DateTime } from 'luxon'

/**
 *
 * @param str
 * @param format      DateTime.DATETIME_MED (Oct 14, 1983, 9:30 AM), DateTime.DATE_MED (Oct 14, 1983) or DateTime.DATE_SHORT (10/14/1983) are the usual.
 * @returns {string}
 */
export default function date(str, format = DateTime.DATE_SHORT) {
  const datetime = DateTime.fromISO(str)

  return datetime /*.setZone('America/New_York')*/
    .toLocaleString(format)
}
